import { makeSceneDoc } from '../kit.js';

/**
 * 市集：全天最吵的地方。
 * 当铺、大车店、车铺围着一地摊位，雇工多半在这里找活。
 */
export const marketDoc = makeSceneDoc({
  id: 'market',
  name: '市集',
  region: 'city',
  tier: 2,
  node: 'market',
  desc: '一股子油烟、马粪和叫卖声。',
  w: 46, h: 28,
  fill: 'o',
  spawn: { gx: 23, gy: 2 },
  draw(b, rng) {
    b.rect(0, 0, 46, 28, 'o');
    b.rect(0, 0, 46, 3, '=');
    b.rect(0, 25, 46, 3, '=');
    // 四家铺子：木地板只铺房子坐的那几格，门口留一格门槛。
    // 早先铺成一整片（9x7），房子只占中间两三格，人能绕到屋后头、站到房顶上，
    // 看着就像门口跟房子对不上。房子由 place_props 按门户自己起，尺寸见 PLACE_SIZES。
    b.rect(4, 7, 3, 2, '.');      b.set(5, 9, '+');    // 当铺  3x2
    b.rect(39, 6, 4, 3, '.');     b.set(40, 9, '+');   // 大车店 4x3
    b.rect(4, 22, 4, 2, '.');     b.set(5, 24, '+');   // 车铺  4x2
    b.rect(39, 22, 3, 2, '.');    b.set(40, 24, '+');  // 早点铺 3x2
    b.rect(12, 10, 22, 8, 'o');
    b.scatter('=', 24, { rng, area: [10, 4, 26, 20] });
  },
  props: [
    // 四家铺子各挂一块路牌：市集大，转一圈找不着车铺的时候就看牌子
    { type: 'signpost', gx: 3, gy: 9, state: { text: '当铺' } },
    { type: 'signpost', gx: 3, gy: 24, state: { text: '车铺' } },
    { type: 'signpost', gx: 43, gy: 9, state: { text: '大车店' } },
    { type: 'signpost', gx: 43, gy: 24, state: { text: '早点铺' } },
    { type: 'nail_stall', gx: 13, gy: 11 },
    { type: 'sundry_stall', gx: 19, gy: 11 },
    { type: 'spice_stall', gx: 25, gy: 11 },
    { type: 'pot_stall', gx: 31, gy: 11 },
    { type: 'tea_stall', gx: 14, gy: 17 },
    { type: 'sesame_stall', gx: 20, gy: 17 },
    { type: 'sugar_stall', gx: 26, gy: 17 },
    { type: 'pickle_stall', gx: 32, gy: 17 },
    { type: 'notice_board', gx: 23, gy: 13 },
    { type: 'lot_bucket', gx: 17, gy: 20 },
    { type: 'lot_bucket', gx: 29, gy: 7 },
  ],
  portals: [
    { to: 'main_street', gx: 23, gy: 1, spawn: [24, 25], label: '主街' },
    { to: 'riverfront', gx: 44, gy: 20, spawn: [3, 12], label: '河埠' },
    { to: 'fun_street', gx: 1, gy: 20, spawn: [40, 14], label: '瓦舍街' },
    { to: 'pawn', gx: 5, gy: 9, spawn: [5, 13], label: '当铺' },
    { to: 'inn', gx: 40, gy: 9, spawn: [6, 13], label: '大车店' },
    { to: 'garage', gx: 5, gy: 24, spawn: [6, 13], label: '车铺' },
    { to: 'eatery', gx: 40, gy: 24, spawn: [6, 13], label: '早点铺' },
  ],
});

export default marketDoc;
